export const hospitalNameById = {
  13: '계명대 동산병원',
  15: '한림대학교춘천성심병원',
  16: '한림대학교성심병원',
  21: '한림대학교동탄성심병원',
  26: '한림대학교강남성심병원',
};
